import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkOrderMandatoryDocumentsAllertComponent } from './work-order-mandatory-documents-allert.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule
  ],
  declarations: [WorkOrderMandatoryDocumentsAllertComponent],
  exports : [WorkOrderMandatoryDocumentsAllertComponent]
})
export class WorkOrderMandatoryDocumentsAllertModule { }
